import {
  Component,
  ElementRef,
  HostListener,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { ParamsService } from '../../../auxiliares/servicios/params.service';
import { ICamara } from 'modelos/src';
import { MaterialModule } from '../../../auxiliares/material.module';
import { CameraPlayerComponent } from '../../../auxiliares/camera-player/camera-player.component';

/**
 * Wrapper de dialog para una cámara. Toda la lógica de fetch + reproducción
 * vive en `app-camera-player`. Este componente solo agrega el header de
 * dialog (drag, close button) cuando se monta como modal.
 */
@Component({
  imports: [CameraPlayerComponent, MaterialModule],
  selector: 'app-stream-camara',
  templateUrl: './stream-camara.component.html',
  styleUrl: './stream-camara.component.scss',
  standalone: true,
})
export class StreamCamaraComponent {
  dialogRef = inject<MatDialogRef<StreamCamaraComponent>>(MatDialogRef, {
    optional: true,
  });
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private cdk = inject(OverlayContainer);
  private el = inject(ElementRef);
  private paramsService = inject(ParamsService);

  @Input() public camara?: ICamara;
  @Input() public canal?: string;
  @Input() public esDialog?: boolean = true;
  @Input() public mainStream?: boolean = true;
  @Input() public controles?: boolean = false;
  @Input() public botonMultiple?: boolean = false;
  @Input() public maximizado?: boolean = false;
  @Output() public camaraEmiter? = new EventEmitter<{
    camara?: ICamara;
    canal?: string;
  }>();
  @Input() public fecha?: string;

  public dragBoundary = document.getElementById('router');

  ngOnInit() {
    this.camara = !this.camara
      ? this.paramsService.getParams()?.['camara']
      : this.camara;
    this.canal = !this.canal
      ? this.paramsService.getParams()?.['canal']
      : this.canal;
  }

  public closeDialog() {
    this.dialogRef?.close();
  }

  // Un clic en cualquier parte del diálogo lo trae al frente. Va en el host y
  // no como (click) en el contenedor de la plantilla: es una superficie, no un
  // botón.
  @HostListener('click')
  public alClicEnDialogo(): void {
    if (this.dialogRef && this.esDialog) this.bringToFront();
  }

  public bringToFront(): void {
    const dialogsContainer = Array.from(
      this.cdk.getContainerElement().childNodes,
    );
    const dialogContainerTagName = 'MAT-DIALOG-CONTAINER';
    const parentEl = this.el.nativeElement.closest(dialogContainerTagName);
    const dialogId = parentEl?.getAttribute('id');
    const focusedDialog = (dialogsContainer as HTMLElement[]).find((el) =>
      el.querySelector(`#${dialogId}`),
    );
    if (focusedDialog) {
      this.cdk.getContainerElement().appendChild(focusedDialog);
    }
  }

  public botonClick() {
    this.camaraEmiter?.emit({ camara: this.camara, canal: this.canal });
  }
}
